import { AxisType, ButtonType, InputDeviceType } from "flavr-common";
export const AXIS_MAPPING = {};
AXIS_MAPPING[InputDeviceType.HtcViveController] = {
    0: { type: AxisType.TOUCHPAD_X },
    1: { type: AxisType.TOUCHPAD_Y },
    2: { type: AxisType.THUMBSTICK_X },
    3: { type: AxisType.THUMBSTICK_Y },
    4: { type: AxisType.TRIGGER }
};
AXIS_MAPPING[InputDeviceType.ValveIndexController] = {
    0: { type: AxisType.TOUCHPAD_X },
    1: { type: AxisType.TOUCHPAD_Y },
    2: { type: AxisType.THUMBSTICK_X },
    3: { type: AxisType.THUMBSTICK_Y },
    4: { type: AxisType.TRIGGER }
};
AXIS_MAPPING[InputDeviceType.OculusController] = {
    0: { type: AxisType.TOUCHPAD_X },
    1: { type: AxisType.TOUCHPAD_Y, invert: true },
    2: { type: AxisType.THUMBSTICK_X },
    3: { type: AxisType.THUMBSTICK_Y },
    4: { type: AxisType.TRIGGER }
};
AXIS_MAPPING[InputDeviceType.Mouse] = {};
AXIS_MAPPING[InputDeviceType.Keyboard] = {};
export const BUTTON_MAPPING = {};
const XR_STANDARD_BUTTON_MAPPING = {
    "0": ButtonType.SELECT, // Trigger Button
    "1": ButtonType.GRAB, // Grab Button
    "2": ButtonType.CLICK, // Trackpad
    "3": ButtonType.CLICK, // Analog Stick
    "4": ButtonType.DISCARD, // Additional Button 1
    "5": ButtonType.BUTTON_A, // Additional Button 2
    "6": ButtonType.DISCARD // Additional Button 3
};
BUTTON_MAPPING[InputDeviceType.HtcViveController] = XR_STANDARD_BUTTON_MAPPING;
BUTTON_MAPPING[InputDeviceType.ValveIndexController] = XR_STANDARD_BUTTON_MAPPING;
BUTTON_MAPPING[InputDeviceType.OculusController] = XR_STANDARD_BUTTON_MAPPING;
BUTTON_MAPPING[InputDeviceType.Mouse] = {
    "0": ButtonType.SELECT,
    "1": ButtonType.CLICK,
    "2": ButtonType.BUTTON_A
};
BUTTON_MAPPING[InputDeviceType.Keyboard] = {
    Escape: ButtonType.DISCARD
};
